// Brand assets & helpers
export const LOGO = 'https://customer-assets-jai6qajn.emergentagent.net/job_d148ad47-2833-4dd9-8a74-a44dc217746d/artifacts/fc7imbb3_image.png';

export const BANNERS = [
  'https://customer-assets-jai6qajn.emergentagent.net/job_d148ad47-2833-4dd9-8a74-a44dc217746d/artifacts/v6kox3if_image.png',
  'https://customer-assets-jai6qajn.emergentagent.net/job_d148ad47-2833-4dd9-8a74-a44dc217746d/artifacts/jig15e4n_image.png',
  'https://customer-assets-jai6qajn.emergentagent.net/job_d148ad47-2833-4dd9-8a74-a44dc217746d/artifacts/gvclm1yv_image.png',
];

export const formatPrice = (n) => 'Rs ' + Number(n || 0).toLocaleString('en-PK');

export const buildWhatsAppMessage = (items, total, customer) => {
  let msg = `*New Order - National Light*%0A%0A`;
  if (customer) {
    if (customer.order_number) msg += `Order: ${customer.order_number}%0A`;
    if (customer.customer_name) msg += `Name: ${customer.customer_name}%0A`;
    if (customer.phone) msg += `Phone: ${customer.phone}%0A`;
    if (customer.address) msg += `Address: ${customer.address}%0A`;
    msg += `%0A`;
  }
  msg += `*Items:*%0A`;
  items.forEach((i, idx) => {
    msg += `${idx + 1}. ${i.name} x${i.quantity} - Rs ${(i.price * i.quantity).toLocaleString('en-PK')}%0A`;
  });
  msg += `%0A*Total: Rs ${Number(total).toLocaleString('en-PK')}*`;
  return msg;
};
